import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/layout/sidebar/icons/pick_up.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_location_pin.svg'
import _imports_2 from '@/app/ui/assets/svg/clock.svg'


const _hoisted_1 = {
  key: 0,
  class: "rounded-xl border border-red-lp-2800 bg-white px-4 py-3 gap-3 relative flex flex-col"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "absolute right-0 top-0 overflow-hidden rounded-xl" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "71",
    height: "59",
    viewBox: "0 0 71 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      cx: "60.6046",
      cy: "-2.39538",
      r: "44.8702",
      fill: "#FF7B9C",
      "fill-opacity": "0.09"
    }),
    /*#__PURE__*/_createVNode("circle", {
      cx: "61",
      cy: "-2",
      r: "61",
      fill: "#FF7B9C",
      "fill-opacity": "0.08"
    })
  ])
], -1)
const _hoisted_3 = { class: "flex flex-row justify-between" }
const _hoisted_4 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_5 = { class: "flex flex-col gap-1" }
const _hoisted_6 = { class: "font-montserrat text-14px text-black-lp-100" }
const _hoisted_7 = {
  "data-testid": "pickup-booking-summary-metrics",
  class: "flex items-center gap-x-2 font-montserrat"
}
const _hoisted_8 = { class: "flex items-center gap-x-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-3002 text-4xl font-bold" }, "•", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-3002 text-4xl font-bold" }, " • ", -1)
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1500",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "flex gap-x-1 text-12px text-gray-lp-800 items-center" }
const _hoisted_15 = { class: "flex gap-2 items-center" }
const _hoisted_16 = { class: "flex items-center gap-x-1 text-12px text-black-lp-100" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-3002 text-xl font-bold" }, "•", -1)
const _hoisted_18 = {
  key: 1,
  "data-testid": "pickup-booking-summary",
  class: "rounded-xl border border-red-lp-2800 bg-white px-4 py-3 gap-3 relative flex flex-col"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "absolute right-0 top-0 overflow-hidden rounded-xl" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "71",
    height: "59",
    viewBox: "0 0 71 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      cx: "60.6046",
      cy: "-2.39538",
      r: "44.8702",
      fill: "#FF7B9C",
      "fill-opacity": "0.09"
    }),
    /*#__PURE__*/_createVNode("circle", {
      cx: "61",
      cy: "-2",
      r: "61",
      fill: "#FF7B9C",
      "fill-opacity": "0.08"
    })
  ])
], -1)
const _hoisted_20 = { class: "flex flex-row justify-between" }
const _hoisted_21 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6",
  alt: "pick_up"
}, null, -1)
const _hoisted_23 = { class: "flex flex-col gap-1" }
const _hoisted_24 = {
  "data-testid": "pickup-booking-summary-title-suggestion",
  class: "font-montserrat text-14px text-black-lp-100"
}
const _hoisted_25 = {
  "data-testid": "pickup-booking-summary-metrics",
  class: "flex items-center gap-x-2 font-montserrat"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "flex items-center gap-x-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-2xl text-black-lp-100 font-bold" }, "0"),
  /*#__PURE__*/_createVNode("span", { class: "text-xl text-black-lp-100 font-medium" }, "AWB")
], -1)
const _hoisted_27 = { class: "text-sm text-black-lp-100 font-normal" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-3002 text-4xl font-bold" }, "•", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "text-xl text-black-lp-100 font-bold" }, "0 kg", -1)
const _hoisted_30 = { class: "flex items-center gap-2" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1500",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_32 = { class: "flex items-center justify-between" }
const _hoisted_33 = { class: "flex gap-x-1 text-12px text-gray-lp-800 items-center" }
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "ics_f_location_pin"
}, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "flex gap-2 items-center"
}
const _hoisted_36 = { class: "font-bold text-black-lp-100 text-xs" }
const _hoisted_37 = { class: "truncate font-medium text-xs text-gray-lp-800 max-w-200px" }
const _hoisted_38 = {
  key: 1,
  class: "flex gap-2 items-center"
}
const _hoisted_39 = { class: "font-medium text-xs text-gray-lp-800 max-w-200px" }
const _hoisted_40 = {
  key: 2,
  "data-testid": "pickup-booking-summary",
  class: "rounded-xl border border-red-lp-2800 bg-white px-4 py-3 gap-3 relative flex flex-col"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "absolute right-0 top-0 overflow-hidden rounded-xl" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "71",
    height: "59",
    viewBox: "0 0 71 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      cx: "60.6046",
      cy: "-2.39538",
      r: "44.8702",
      fill: "#FF7B9C",
      "fill-opacity": "0.09"
    }),
    /*#__PURE__*/_createVNode("circle", {
      cx: "61",
      cy: "-2",
      r: "61",
      fill: "#FF7B9C",
      "fill-opacity": "0.08"
    })
  ])
], -1)
const _hoisted_42 = { class: "flex flex-row justify-between" }
const _hoisted_43 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6",
  alt: "pick_up"
}, null, -1)
const _hoisted_45 = { class: "flex flex-col gap-1" }
const _hoisted_46 = {
  "data-testid": "pickup-booking-summary-title-suggestion",
  class: "font-montserrat text-14px text-black-lp-100"
}
const _hoisted_47 = {
  "data-testid": "pickup-booking-summary-metrics",
  class: "flex items-center gap-x-2 font-montserrat"
}
const _hoisted_48 = { class: "flex items-center gap-x-2" }
const _hoisted_49 = { class: "text-2xl text-black-lp-100 font-bold" }
const _hoisted_50 = { class: "text-xl text-black-lp-100 font-medium" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-3002 text-4xl font-bold" }, "•", -1)
const _hoisted_52 = { class: "text-xl text-black-lp-100 font-bold" }
const _hoisted_53 = {
  key: 0,
  class: "text-gray-lp-3002 text-4xl font-bold"
}
const _hoisted_54 = {
  key: 1,
  class: "bg-red-lp-3100 text-red-lp-2400 text-sm px-1 py-0.5 rounded font-medium inline-block"
}
const _hoisted_55 = {
  key: 2,
  class: "bg-yellow-lp-1800 text-yellow-lp-100 text-sm px-1 py-0.5 rounded font-medium inline-block"
}
const _hoisted_56 = {
  key: 3,
  class: "bg-chocolate-lp-400 py-0.5 px-1 text-white font-bold rounded text-sm inline-block"
}
const _hoisted_57 = { class: "flex items-center gap-2" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-gray-lp-1500",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_59 = { class: "flex items-center justify-between" }
const _hoisted_60 = { class: "flex gap-x-1 text-12px text-gray-lp-800 items-center" }
const _hoisted_61 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "ics_f_location_pin"
}, null, -1)
const _hoisted_62 = {
  key: 0,
  class: "flex gap-2 items-center"
}
const _hoisted_63 = { class: "font-bold text-black-lp-100 text-xs" }
const _hoisted_64 = { class: "truncate font-medium text-xs text-gray-lp-800 max-w-200px" }
const _hoisted_65 = {
  key: 1,
  class: "flex gap-2 items-center"
}
const _hoisted_66 = { class: "font-medium text-xs text-gray-lp-800 max-w-200px" }
const _hoisted_67 = {
  key: 0,
  "data-testid": "pickup-booking-summary-nearest-schedule",
  class: "flex items-center gap-x-1 text-12px text-black-lp-100"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4 h-4",
  alt: "clock"
}, null, -1)
const _hoisted_69 = { class: "font-semibold" }
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-3002 text-xl font-bold" }, "•", -1)
const _hoisted_71 = { class: "font-semibold" }
const _hoisted_72 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_73 = { class: "text-sm text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Skeleton, {
              height: "2rem",
              width: "2rem"
            }),
            _createVNode("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "12rem"
                })
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_Skeleton, {
                    height: "2rem",
                    width: "2rem"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "1.5rem",
                    width: "6rem"
                  })
                ]),
                _createVNode(_component_Skeleton, {
                  height: "1.5rem",
                  width: "6rem"
                }),
                _hoisted_9,
                _createVNode(_component_Skeleton, {
                  height: "1.5rem",
                  width: "6rem"
                }),
                _hoisted_10,
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "4rem"
                }),
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "3rem"
                }),
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "6rem"
                })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Skeleton, {
              height: "2rem",
              width: "12rem"
            }),
            _createVNode(_component_Skeleton, {
              height: "2rem",
              width: "7rem"
            }),
            _createVNode(_component_Skeleton, {
              height: "2rem",
              width: "9rem"
            })
          ])
        ]),
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "1.5rem"
            }),
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_Skeleton, {
                height: "1.5rem",
                width: "8rem"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.5rem",
                width: "10rem"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.5rem",
                width: "4rem"
              })
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "4rem"
            }),
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "6rem"
            }),
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "6rem"
            }),
            _hoisted_17,
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "4rem"
            })
          ])
        ])
      ]))
    : (_ctx.isEmptyFromListBooking)
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("pickup.bookingSummary.titleBucket")), 1),
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("span", _hoisted_27, "(0 " + _toDisplayString(_ctx.$t("pickup.bookingSummary.piece")) + ")", 1),
                  _hoisted_28,
                  _hoisted_29
                ])
              ])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_LpButton, {
                "data-testid": "pickup-booking-summary-button-request-pickup",
                title: _ctx.$t('pickup.bookingSummary.requestPickup'),
                outline: "",
                color: "red-lp-2400",
                textColor: "red-lp-2400",
                fontWeight: "semibold",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('request-pickup'))),
                disabled: !_ctx.validationAccount
              }, null, 8, ["title", "disabled"])
            ])
          ]),
          _hoisted_31,
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _hoisted_34,
              (_ctx.summaryData.addressLine)
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    _createVNode("p", _hoisted_36, _toDisplayString(_ctx.summaryData.contactName) + " - " + _toDisplayString(_ctx.summaryData.contactPhone), 1),
                    _createVNode("p", _hoisted_37, _toDisplayString(_ctx.summaryData.addressLine), 1),
                    (_ctx.showChangeAddress)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          "data-testid": "pickup-booking-summary-button-change-address",
                          class: "text-red-lp-2400 font-semibold text-xs",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('ubah-alamat')))
                        }, _toDisplayString(_ctx.$t("pickup.bookingSummary.changeAddress")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_38, [
                    _createVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("pickup.bookingSummary.addressIsEmpty")), 1),
                    (_ctx.showChangeAddress)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          "data-testid": "pickup-booking-summary-button-change-address",
                          class: "text-red-lp-2400 font-semibold text-xs",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('tambah-alamat')))
                        }, _toDisplayString(_ctx.$t("pickup.bookingSummary.addAddress")), 1))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ]))
      : (_ctx.summaryData.state !== 'none')
        ? (_openBlock(), _createBlock("div", _hoisted_40, [
            _hoisted_41,
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("div", _hoisted_45, [
                  _createVNode("span", _hoisted_46, _toDisplayString(_ctx.summaryData.state === "suggestion"
                ? _ctx.$t("pickup.bookingSummary.titleSuggestion")
                : _ctx.$t("pickup.bookingSummary.titleBucket")), 1),
                  _createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _createVNode("span", _hoisted_49, _toDisplayString(_ctx.summaryData.state === "suggestion"
                  ? _ctx.summaryData.koliCount || 0
                  : _ctx.summaryData.sttCount || 0), 1),
                      _createVNode("span", _hoisted_50, _toDisplayString(_ctx.summaryData.state === "suggestion"
                  ? _ctx.$t("pickup.bookingSummary.piece")
                  : "AWB"), 1)
                    ]),
                    _withDirectives(_createVNode("span", { class: "text-sm text-black-lp-100 font-normal" }, "(" + _toDisplayString(_ctx.summaryData.koliCount || 0) + " " + _toDisplayString(_ctx.$t("pickup.bookingSummary.piece")) + ")", 513), [
                      [_vShow, _ctx.summaryData.state !== 'suggestion']
                    ]),
                    _hoisted_51,
                    _createVNode("span", _hoisted_52, _toDisplayString(_ctx.summaryData.weightKg || 0) + " kg", 1),
                    (_ctx.summaryData.specialHandling.length)
                      ? (_openBlock(), _createBlock("span", _hoisted_53, "•"))
                      : _createCommentVNode("", true),
                    (_ctx.summaryData.specialHandling.includes('dangerous_goods'))
                      ? (_openBlock(), _createBlock("span", _hoisted_54, " DG "))
                      : _createCommentVNode("", true),
                    (_ctx.summaryData.specialHandling.includes('quarantine'))
                      ? (_openBlock(), _createBlock("span", _hoisted_55, " K "))
                      : _createCommentVNode("", true),
                    (_ctx.summaryData.specialHandling.includes('wood_packing'))
                      ? (_openBlock(), _createBlock("span", _hoisted_56, _toDisplayString(_ctx.$t("pickup.bookingSummary.wood")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_57, [
                (
            _ctx.summaryData.state === 'bucket' &&
              _ctx.summaryData.showActivePickupCta &&
              _ctx.showPickupCta
          )
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      "data-testid": "pickup-booking-summary-button-view-stt",
                      title: 
            _ctx.$t('pickup.bookingSummary.viewActivePickup', {
              count: _ctx.summaryData.activePickupCount
                ? `(${_ctx.summaryData.activePickupCount})`
                : ''
            })
          ,
                      outline: "",
                      color: "gray-lp-1600",
                      textColor: "black-lp-100",
                      fontWeight: "semibold",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('lihat-pickup-aktif')))
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                (_ctx.summaryData.state === 'bucket')
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 1,
                      "data-testid": "pickup-booking-summary-button-view-stt",
                      title: _ctx.$t('pickup.bookingSummary.viewStt'),
                      outline: "",
                      color: _ctx.isSttCorporate ? 'red-lp-2400' : 'gray-lp-1600',
                      textColor: _ctx.isSttCorporate ? 'red-lp-2400' : 'black-lp-100',
                      bgOutline: _ctx.isSttCorporate ? 'bg-red-lp-1100' : 'bg-white',
                      fontWeight: "semibold",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('lihat-stt')))
                    }, null, 8, ["title", "color", "textColor", "bgOutline"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_LpButton, {
                  "data-testid": "pickup-booking-summary-button-request-pickup",
                  title: _ctx.$t('pickup.bookingSummary.requestPickup'),
                  outline: "",
                  color: "red-lp-2400",
                  textColor: "red-lp-2400",
                  fontWeight: "semibold",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('request-pickup'))),
                  disabled: !_ctx.validationAccount
                }, null, 8, ["title", "disabled"])
              ])
            ]),
            _hoisted_58,
            _createVNode("div", _hoisted_59, [
              _createVNode("div", _hoisted_60, [
                _hoisted_61,
                (_ctx.summaryData.addressLine)
                  ? (_openBlock(), _createBlock("div", _hoisted_62, [
                      _createVNode("p", _hoisted_63, _toDisplayString(_ctx.summaryData.contactName) + " - " + _toDisplayString(_ctx.summaryData.contactPhone), 1),
                      _createVNode("p", _hoisted_64, _toDisplayString(_ctx.summaryData.addressLine), 1),
                      (_ctx.showChangeAddress)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            "data-testid": "pickup-booking-summary-button-change-address",
                            class: "text-red-lp-2400 font-semibold text-xs",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('ubah-alamat')))
                          }, _toDisplayString(_ctx.$t("pickup.bookingSummary.changeAddress")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_65, [
                      _createVNode("p", _hoisted_66, _toDisplayString(_ctx.$t("pickup.bookingSummary.addressIsEmpty")), 1),
                      (_ctx.showChangeAddress)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            "data-testid": "pickup-booking-summary-button-change-address",
                            class: "text-red-lp-2400 font-semibold text-xs",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('tambah-alamat')))
                          }, _toDisplayString(_ctx.$t("pickup.bookingSummary.addAddress")), 1))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              (_ctx.summaryData.nearestScheduleLabel)
                ? (_openBlock(), _createBlock("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode("span", null, _toDisplayString(_ctx.$t("pickup.bookingSummary.nearestSchedule")), 1),
                    _createVNode("span", _hoisted_69, _toDisplayString(_ctx.summaryDate.date), 1),
                    _hoisted_70,
                    _createVNode("span", _hoisted_71, _toDisplayString(_ctx.summaryDate.time), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createBlock("div", {
            key: 3,
            "data-testid": "pickup-booking-summary-empty",
            class: ["rounded-xl bg-white px-3 py-2 flex items-center", {
      'justify-end': _ctx.isInternalAccount,
      'justify-between': !_ctx.isInternalAccount
    }]
          }, [
            (!_ctx.isInternalAccount)
              ? (_openBlock(), _createBlock("div", _hoisted_72, [
                  _createVNode(_component_Icons, {
                    width: "24",
                    height: "24",
                    name: "warning-circle",
                    color: "#78787A"
                  }),
                  _createVNode("span", _hoisted_73, _toDisplayString(_ctx.$t("pickup.bookingSummary.empty")), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_LpButton, {
              "data-testid": "pickup-booking-summary-button-create-manual",
              title: _ctx.$t('pickup.bookingSummary.createManual'),
              color: "red-lp-2400",
              textColor: "white",
              fontWeight: "semibold",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('buat-pickup-manual'))),
              disabled: !_ctx.validationAccount
            }, null, 8, ["title", "disabled"])
          ], 2))
}